import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

// Configurar flags futuras do React Router v7
export const routerConfig = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};
